export default "__VITE_ASSET__DtAeAih1__"